import IApi from 'modules/shared/domain/IApi';
import api from 'modules/shared/infrastructure/api/Api';
import BaseRepository from 'modules/shared/infrastructure/repositories/BaseRepository';
import * as URL from './urls';
import IChartDataRepository from './IChartDataRepository';

class ChartDataRepository
  extends BaseRepository
  implements IChartDataRepository
{
  private readonly _api: IApi;
  private readonly _apiGetChartData: string;

  constructor({ api, apiGetChartData }) {
    super();
    this._api = api;
    this._apiGetChartData = apiGetChartData;
  }

  getChartData({ queryParams }: { queryParams: object }) {
    return this._api
      .get(`${this._apiGetChartData}${this._createQueryParams(queryParams)}`)
      .then((res) => {
        return res;
      });
  }
}

export default new ChartDataRepository({
  api: api,
  apiGetChartData: URL.API_GET_CHART_DATA
});

export { ChartDataRepository };
